
export const validateClasses=(classes,mutate)=>{
if(classes&&!mutate){
throw new Error(
"The \"mutate\" option must be true when the \"classes\" option is true."
)
}
};


export const validateInherited=({classes,inherited})=>{
if(inherited&&!classes){
throw new Error(
"The \"classes\" option must be true when the \"inherited\" option is true."
)
}
};




export const validateMissing=({missing,entries})=>{
if(missing&&!entries){
throw new Error(
"The \"entries\" option must be true when the \"missing\" option is true."
)
}
};


export const validateLeaves=({roots,leaves})=>{
if(roots&&leaves){
throw new Error(
"The \"roots\" and \"leaves\" options must not be true at the same time."
)
}
};